import { useCallback, useEffect, useRef } from 'react';

// Custom hook for managing event listeners with cleanup
export const useEventManager = () => {
  const eventListeners = useRef(new Map<string, Set<EventListener>>());

  const addManagedEventListener = useCallback(
    (event: string, handler: EventListener) => {
      if (!eventListeners.current.has(event)) {
        eventListeners.current.set(event, new Set());
      }
      eventListeners.current.get(event)!.add(handler);
      window.addEventListener(event, handler);
    },
    []
  );

  useEffect(() => {
    const currentEventListeners = eventListeners.current;

    return () => {
      // Remove all managed event listeners on cleanup
      currentEventListeners.forEach((handlers, event) => {
        handlers.forEach(handler => {
          window.removeEventListener(event, handler);
        });
      });
      currentEventListeners.clear();
    };
  }, []);

  return { addManagedEventListener };
};